import { VRProduct } from '../babylonjs/type/vrType'

export const vrProducts: VRProduct[] = [
  {
    modelId: 'chairModular',
    productPackageId: 'a094c13b-b1c8-40a6-9746-15b70fa57cb1',
    position: {
      x: -1.91,
      y: 0.02,
      z: -2.372,
    },
    transform: {
      rotation: { x: 0, y: -130, z: 0 },
      scale: {
        x: 0.2,
        y: 0.2,
        z: 0.2,
      },
    },
  },
  {
    modelId: '9228c95d-8dd6-44cd-8baa-e3c3be3559e4',
    productPackageId: 'b2fdf1f6-7fe1-4a58-b1a0-fe8c8dd6c1bf',
    position: {
      x: -6.15,
      y: 0.02,
      z: -8.1,
    },
    transform: {
      rotation: { x: 0, y: -180, z: 0 },
      scale: {
        x: 0.01,
        y: 0.01,
        z: 0.01,
      },
    },
  },
]
